module.exports = __webpack_public_path__ + "img/3cabinet.ec9dd045.svg";